import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g
      fill="currentColor"
      fillRule="evenodd"
      clipPath="url(#icon-TextAa_svg__a)"
      clipRule="evenodd"
    >
      <path d="M10.884 6.532a1 1 0 0 0-1.768 0l-9 17a1 1 0 0 0 1.768.936L4.249 20h11.502l2.365 4.468a1 1 0 1 0 1.768-.936zM14.692 18 10 9.137 5.308 18zM26 16.363c1.096 0 2.147.328 3 .9v-.9c0-1.264-1.21-2.5-3-2.5h-.011a3.26 3.26 0 0 0-2.296.908 1 1 0 0 1-1.386-1.442 5.26 5.26 0 0 1 3.699-1.466c2.632.002 4.994 1.89 4.994 4.5V24a1 1 0 0 1-1.915.404 5.4 5.4 0 0 1-3.085.959c-2.632 0-5-1.894-5-4.5 0-2.607 2.368-4.5 5-4.5m-3 4.5c0-1.26 1.213-2.5 3-2.5s3 1.24 3 2.5c0 1.259-1.213 2.5-3 2.5s-3-1.241-3-2.5" />
    </g>
    <defs>
      <clipPath id="icon-TextAa_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
const SvgIconTextAa = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconTextAa);
export default Memo;
